module.exports = __webpack_public_path__ + "static/media/bestCheckList.5e37164c.svg";